import React from 'react';

const Blog = () => {
  return (
    <div>
      <h1>A blog</h1>
      <p>opinions</p>
    </div>
  );
};

export default Blog;